import { createFileRoute } from '@tanstack/react-router';
import { SprintModule } from '@/features/sprint/SprintModule';

export const Route = createFileRoute('/_app/sprint')({ component: SprintModule });
